//# sourceMappingURL=weaviate.mjs.map
/// <reference types="./weaviate.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { toList, CustomType as $CustomType } from "../gleam.mjs";

export class Document extends $CustomType {}
export const CollectionKind$Document = () => new Document();
export const CollectionKind$isDocument = (value) => value instanceof Document;

export class Chunk extends $CustomType {}
export const CollectionKind$Chunk = () => new Chunk();
export const CollectionKind$isChunk = (value) => value instanceof Chunk;

export class Base extends $CustomType {}
export const CollectionVariant$Base = () => new Base();
export const CollectionVariant$isBase = (value) => value instanceof Base;

export class V2 extends $CustomType {}
export const CollectionVariant$V2 = () => new V2();
export const CollectionVariant$isV2 = (value) => value instanceof V2;

export class Collection extends $CustomType {
  constructor(index_name, nb_objects) {
    super();
    this.index_name = index_name;
    this.nb_objects = nb_objects;
  }
}
export const Collection$Collection = (index_name, nb_objects) =>
  new Collection(index_name, nb_objects);
export const Collection$isCollection = (value) => value instanceof Collection;
export const Collection$Collection$index_name = (value) => value.index_name;
export const Collection$Collection$0 = (value) => value.index_name;
export const Collection$Collection$nb_objects = (value) => value.nb_objects;
export const Collection$Collection$1 = (value) => value.nb_objects;

export class Ongoing extends $CustomType {}
export const MigrationStatus$Ongoing = () => new Ongoing();
export const MigrationStatus$isOngoing = (value) => value instanceof Ongoing;

export class Completed extends $CustomType {}
export const MigrationStatus$Completed = () => new Completed();
export const MigrationStatus$isCompleted = (value) =>
  value instanceof Completed;

export class Failed extends $CustomType {}
export const MigrationStatus$Failed = () => new Failed();
export const MigrationStatus$isFailed = (value) => value instanceof Failed;

export class MigrationRun extends $CustomType {
  constructor(org_id, run_id, previous_run_id, collection_kind, source_variant, target_variant, status) {
    super();
    this.org_id = org_id;
    this.run_id = run_id;
    this.previous_run_id = previous_run_id;
    this.collection_kind = collection_kind;
    this.source_variant = source_variant;
    this.target_variant = target_variant;
    this.status = status;
  }
}
export const MigrationRun$MigrationRun = (org_id, run_id, previous_run_id, collection_kind, source_variant, target_variant, status) =>
  new MigrationRun(org_id,
  run_id,
  previous_run_id,
  collection_kind,
  source_variant,
  target_variant,
  status);
export const MigrationRun$isMigrationRun = (value) =>
  value instanceof MigrationRun;
export const MigrationRun$MigrationRun$org_id = (value) => value.org_id;
export const MigrationRun$MigrationRun$0 = (value) => value.org_id;
export const MigrationRun$MigrationRun$run_id = (value) => value.run_id;
export const MigrationRun$MigrationRun$1 = (value) => value.run_id;
export const MigrationRun$MigrationRun$previous_run_id = (value) =>
  value.previous_run_id;
export const MigrationRun$MigrationRun$2 = (value) => value.previous_run_id;
export const MigrationRun$MigrationRun$collection_kind = (value) =>
  value.collection_kind;
export const MigrationRun$MigrationRun$3 = (value) => value.collection_kind;
export const MigrationRun$MigrationRun$source_variant = (value) =>
  value.source_variant;
export const MigrationRun$MigrationRun$4 = (value) => value.source_variant;
export const MigrationRun$MigrationRun$target_variant = (value) =>
  value.target_variant;
export const MigrationRun$MigrationRun$5 = (value) => value.target_variant;
export const MigrationRun$MigrationRun$status = (value) => value.status;
export const MigrationRun$MigrationRun$6 = (value) => value.status;

export const all_variants = /* @__PURE__ */ toList([
  /* @__PURE__ */ new Base(),
  /* @__PURE__ */ new V2(),
]);

export function collection_decoder() {
  return $decode.field(
    "index_name",
    $decode.string,
    (index_name) => {
      return $decode.field(
        "nb_objects",
        $decode.int,
        (nb_objects) => {
          return $decode.success(new Collection(index_name, nb_objects));
        },
      );
    },
  );
}

export function status_to_string(status) {
  if (status instanceof Ongoing) {
    return "ongoing";
  } else if (status instanceof Completed) {
    return "completed";
  } else {
    return "failed";
  }
}

export function variant_to_string(variant) {
  if (variant instanceof Base) {
    return "base";
  } else {
    return "v2";
  }
}

export function encode_collection_variant(variant) {
  let _pipe = variant;
  let _pipe$1 = variant_to_string(_pipe);
  return $json.string(_pipe$1);
}

export function kind_to_string(kind) {
  if (kind instanceof Document) {
    return "document";
  } else {
    return "chunk";
  }
}

export function encode_weaviate_migration_run(run) {
  return $json.object(
    toList([
      ["org_id", $json.string(run.org_id)],
      ["run_id", $json.string(run.run_id)],
      ["previous_run_id", $json.nullable(run.previous_run_id, $json.string)],
      ["collection_kind", $json.string(kind_to_string(run.collection_kind))],
      ["source_variant", encode_collection_variant(run.source_variant)],
      ["target_variant", encode_collection_variant(run.target_variant)],
      ["status", $json.string(status_to_string(run.status))],
    ]),
  );
}

function status_decoder() {
  return $decode.then$(
    $decode.string,
    (s) => {
      if (s === "ongoing") {
        return $decode.success(new Ongoing());
      } else if (s === "completed") {
        return $decode.success(new Completed());
      } else if (s === "failed") {
        return $decode.success(new Failed());
      } else {
        return $decode.failure(new Ongoing(), "MigrationStatus");
      }
    },
  );
}

export function collection_variant_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "base") {
        return $decode.success(new Base());
      } else if (value === "v2") {
        return $decode.success(new V2());
      } else {
        return $decode.failure(new Base(), "CollectionVariant");
      }
    },
  );
}

export function collection_kind_decoder() {
  return $decode.then$(
    $decode.string,
    (value) => {
      if (value === "document") {
        return $decode.success(new Document());
      } else if (value === "chunk") {
        return $decode.success(new Chunk());
      } else {
        return $decode.failure(new Chunk(), "CollectionKind");
      }
    },
  );
}

export function weaviate_migration_run_decoder() {
  return $decode.field(
    "org_id",
    $decode.string,
    (org_id) => {
      return $decode.field(
        "run_id",
        $decode.string,
        (run_id) => {
          return $decode.field(
            "previous_run_id",
            $decode.optional($decode.string),
            (previous_run_id) => {
              return $decode.field(
                "collection_kind",
                collection_kind_decoder(),
                (collection_kind) => {
                  return $decode.field(
                    "source_variant",
                    collection_variant_decoder(),
                    (source_variant) => {
                      return $decode.field(
                        "target_variant",
                        collection_variant_decoder(),
                        (target_variant) => {
                          return $decode.field(
                            "status",
                            status_decoder(),
                            (status) => {
                              return $decode.success(
                                new MigrationRun(
                                  org_id,
                                  run_id,
                                  previous_run_id,
                                  collection_kind,
                                  source_variant,
                                  target_variant,
                                  status,
                                ),
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}
